module.exports = __webpack_public_path__ + "img/boton_ordenar_od.1967c265.svg";